import React from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Skeleton } from '@mui/material';
import { useFeatureFlag } from 'modules/common/hooks';
const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    height: '100%',
    marginTop: ({
      isTiAutoAcceptUserSettingsEnabled
    }: {
      isTiAutoAcceptUserSettingsEnabled: boolean;
    }) =>
      isTiAutoAcceptUserSettingsEnabled ? theme.spacing(0) : theme.spacing(2),
    marginLeft: theme.spacing(0.5)
  },
  firstBox: {
    height: 60,
    minWidth: '22.5%',
    marginLeft: theme.spacing(1),
    background: theme.skelton?.color
  },
  secondBox: {
    minWidth: '2.5%',
    height: 25,
    marginLeft: theme.spacing(1),
    background: theme.skelton?.color
  },
  lastBox: {
    minWidth: '10%',
    height: 60,
    background: theme.skelton?.color,
    marginLeft: theme.spacing(1)
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(-0.75),
    flexDirection: 'row'
  },
  lastRow: {
    marginTop: theme.spacing(0)
  },
  defaultValue: {
    minWidth: '10%',
    height: theme.spacing(2.75),
    marginLeft: theme.spacing(1),
    background: theme.skelton?.color
  },
  saveButton: {
    width: theme.spacing(10),
    height: theme.spacing(7),
    marginLeft: theme.spacing(1),
    background: theme.skelton?.color
  }
}));

export const StartEndSettingsPageSkeleton: React.FC = () => {
  const isTiAutoAcceptUserSettingsEnabled = useFeatureFlag(
    'isTiAutoAcceptUserSettingsEnabled'
  );
  const classes = useStyles({ isTiAutoAcceptUserSettingsEnabled });
  const RowItem = () => (
    <Box className={classes.row}>
      <Skeleton className={classes.firstBox} />
      <Skeleton className={classes.secondBox} />
      <Skeleton className={classes.lastBox} />
      <Skeleton className={classes.lastBox} />
      <Skeleton className={classes.lastBox} />
    </Box>
  );
  return (
    <Box className={classes.container} data-testid={'setting-skeleton'}>
      <RowItem />
      <Box className={classes.row}>
        <Skeleton className={classes.firstBox} />
        <Skeleton className={classes.secondBox} />
        <Skeleton className={classes.defaultValue} />
      </Box>

      <Box className={classes.lastRow}>
        <Skeleton className={classes.saveButton} />
      </Box>
    </Box>
  );
};
